import ApiService from '@/services/core/api.service'

const ReportService = {
  async getCallLogs (query) {
    return ApiService.get(`agent/reports/call-logs?${query}`)
  },

  async getConnectedSummaries (query) {
    return ApiService.get(`agent/reports/connected-summaries?${query}`)
  },

  async getUnsuccessfulSummaries (query) {
    return ApiService.get(`agent/reports/unsuccessful-summaries?${query}`)
  },

  async getPromotionSummaries (query) {
    return ApiService.get(`agent/reports/promotion-summaries?${query}`)
  },

  async getVisitRequestHistories (query) {
    return ApiService.get(`agent/reports/visit-request-histories?${query}`)
  },

  async getCallRequestHistories (query) {
    return ApiService.get(`agent/reports/call-request-histories?${query}`)
  },

  async getSMSSummaries (query) {
    return ApiService.get(`agent/reports/sms-summaries?${query}`)
  },

  async getSatisfactionSurvey (query) {
    return ApiService.get(`agent/reports/satisfaction-surveys?${query}`)
  }
}

export default ReportService
